<div id="wrapper">
  <app-topbar
    (mobileMenuButtonClicked)="onToggleMobileMenu()"
    layoutType="vertical"
  ></app-topbar>

  <app-sidebar [includeUserProfile]="showSidebarUserInfo"></app-sidebar>
  <div class="content-page">
    <div class="content">
      <div class="container-fluid" *ngIf="reRender">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>

<ng-template #capabilitiesUpdateModal let-modal>
  <div class="modal-body">
    <div class="text-center">
      <i class="dripicons-warning h1"></i>
      <h4 class="mt-2">
        {{ "user_config_capabilities_updated.title" | translate }}
      </h4>
      <p class="mt-3 text-dark">
        {{ "user_config_capabilities_updated.message" | translate }}
      </p>
      <button
        type="button"
        class="btn btn-dark my-2"
        (click)="acceptAndReload()"
      >
        {{ "user_config_capabilities_updated.button" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #tenantsUpdateModal let-modal>
  <div class="modal-body">
    <div class="text-center">
      <i class="dripicons-warning h1"></i>
      <h4 class="mt-2">
        {{ "user_config_tenants_updated.title" | translate }}
      </h4>
      <p class="mt-3 text-dark">
        {{ "user_config_tenants_updated.message" | translate }}
      </p>
      <button
        type="button"
        class="btn btn-dark my-2"
        (click)="acceptAndReloadTenants()"
      >
        {{ "user_config_tenants_updated.button" | translate }}
      </button>
    </div>
  </div>
</ng-template>
